/** Milliseconds since a reading was fetched, or null if there has never been one. */
export function ageMs(fetchedAt: number | null): number | null {
  return fetchedAt == null ? null : Date.now() - fetchedAt;
}
